import React from "react";

interface GradientBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`min-h-dvh bg-xcf-gradient ${className}`}>{children}</div>
  );
};
